(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react/jsx-runtime"), require("react"), require("@emotion/react"), require("@emotion/css"), require("@payfit/midnight-utils"));
	else if(typeof define === 'function' && define.amd)
		define("midnight", ["react/jsx-runtime", "react", "@emotion/react", "@emotion/css", "@payfit/midnight-utils"], factory);
	else if(typeof exports === 'object')
		exports["midnight"] = factory(require("react/jsx-runtime"), require("react"), require("@emotion/react"), require("@emotion/css"), require("@payfit/midnight-utils"));
	else
		root["midnight"] = factory(root["react/jsx-runtime"], root["react"], root["@emotion/react"], root["@emotion/css"], root["@payfit/midnight-utils"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE__emotion_react__, __WEBPACK_EXTERNAL_MODULE__emotion_css__, __WEBPACK_EXTERNAL_MODULE__payfit_midnight_utils__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/Actionable/Actionable.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Actionable": () => (/* binding */ Actionable)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_useAccessibilityListener__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/helpers/useAccessibilityListener/useAccessibilityListener.tsx");
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/Box/Box.tsx");
/* harmony import */ var _helpers_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/helpers/element/element.ts");
/* harmony import */ var _helpers_nodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/nodash/index.ts");
/* harmony import */ var _ref__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/Actionable/ref.ts");







const isActionableKeyboardKey = (event) => {
  return [" ", "Enter"].includes(event.key);
};
const isNavigableKeyboardKey = (event) => {
  return ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Tab"].includes(
    event.code
  );
};
const Actionable = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(
  function Actionable2(props, ref) {
    const {
      accessibilityRole,
      isDisabled,
      cursor = isDisabled ? "not-allowed" : "pointer",
      onAction = _helpers_nodash__WEBPACK_IMPORTED_MODULE_2__.noop,
      onActiveChange = _helpers_nodash__WEBPACK_IMPORTED_MODULE_2__.noop,
      onFocusChange = _helpers_nodash__WEBPACK_IMPORTED_MODULE_2__.noop,
      onHoverChange = _helpers_nodash__WEBPACK_IMPORTED_MODULE_2__.noop,
      onNavigationKeyDown,
      renderAs,
      type = "button",
      tabIndex,
      ...restProps
    } = props;
    const actionableRef = (0,_ref__WEBPACK_IMPORTED_MODULE_3__.useActionableRef)(ref);
    const { getFocusRingVisibility } = (0,_helpers_useAccessibilityListener__WEBPACK_IMPORTED_MODULE_4__.useAccessibilityListener)();
    const [isFocused, setFocusState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [isActive, setActiveState] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    if (isDisabled && isFocused) {
      setFocusState(false);
      onFocusChange(false);
    }
    const setActiveStateWithCallback = (isActiveFlag) => {
      setActiveState(isActiveFlag);
      onActiveChange(isActiveFlag);
    };
    const handleFocus = () => {
      setFocusState(true);
      onFocusChange(true);
    };
    const handleBlur = () => {
      setFocusState(false);
      onFocusChange(false);
      if (isActive) {
        setActiveStateWithCallback(false);
      }
    };
    const handleMouseDown = () => {
      setActiveStateWithCallback(true);
    };
    const handleMouseUp = () => {
      setActiveStateWithCallback(false);
    };
    const handleMouseEnter = () => {
      onHoverChange(true);
    };
    const handleMouseLeave = ({ currentTarget }) => {
      if (isActive) {
        currentTarget.blur();
        setActiveStateWithCallback(false);
      }
      onHoverChange(false);
    };
    const handleKeyUp = (event) => {
      if (isActionableKeyboardKey(event)) {
        setActiveStateWithCallback(false);
        actionableRef.current.click();
      }
    };
    const handleKeyDown = (event) => {
      if (isActionableKeyboardKey(event)) {
        event.preventDefault();
        setActiveStateWithCallback(true);
      } else if (isNavigableKeyboardKey(event) && onNavigationKeyDown) {
        onNavigationKeyDown(event);
      }
    };
    const eventHandlers = isDisabled ? {} : {
      onBlur: handleBlur,
      onClick: onAction,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      onMouseDown: handleMouseDown,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onMouseUp: handleMouseUp
    };
    const renderAsType = (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(renderAs) ? renderAs.type : renderAs;
    const elementProps = !renderAs || renderAsType === "button" ? {
      disabled: isDisabled,
      role: accessibilityRole,
      type
    } : {
      "aria-disabled": isDisabled,
      role: accessibilityRole || "button",
      tabIndex: tabIndex ? tabIndex : isDisabled ? void 0 : 0
    };
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
      _Box__WEBPACK_IMPORTED_MODULE_5__.Box,
      {
        ref: actionableRef,
        renderAs: (0,_helpers_element__WEBPACK_IMPORTED_MODULE_6__.element)(
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {}),
          {
            ...elementProps,
            ...eventHandlers
          },
          renderAs
        ),
        cursor,
        withOutline: isFocused && getFocusRingVisibility() && !isDisabled,
        flexShrink: 0,
        ...restProps
      }
    );
  }
);


/***/ }),

/***/ "./src/Actionable/ref.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useActionableRef": () => (/* binding */ useActionableRef)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const useActionableRef = (actionableRef) => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(actionableRef, () => ({
    focus: () => {
      ref.current.focus();
    }
  }));
  return ref;
};


/***/ }),

/***/ "./src/Box/Box.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Box": () => (/* binding */ Box)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_element__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("./src/helpers/element/element.ts");
/* harmony import */ var _helpers_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/color/index.ts");
/* harmony import */ var _helpers_animation_useAnimatedProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/animation/useAnimatedProps.ts");
/* harmony import */ var _helpers_properties_accessibility__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("./src/helpers/properties/accessibility.ts");
/* harmony import */ var _helpers_properties_border__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./src/helpers/properties/border.ts");
/* harmony import */ var _helpers_properties_transforms__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("./src/helpers/properties/transforms.ts");
/* harmony import */ var _helpers_properties_visiblyHidden__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("./src/helpers/properties/visiblyHidden/visiblyHidden.ts");
/* harmony import */ var _helpers_properties_testing__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("./src/helpers/properties/testing.ts");
/* harmony import */ var _helpers_properties_shadow__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("./src/helpers/properties/shadow/mapPropsToShadow.ts");
/* harmony import */ var _helpers_properties_stacking__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./src/helpers/properties/stacking.ts");
/* harmony import */ var _helpers_properties_dimension__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/helpers/properties/dimension.ts");
/* harmony import */ var _helpers_properties_position__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/helpers/properties/position.ts");
/* harmony import */ var _helpers_properties_flexChild__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/helpers/properties/flexChild.ts");
/* harmony import */ var _helpers_properties_flexContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/helpers/properties/flexContainer.ts");
/* harmony import */ var _helpers_properties_padding__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/helpers/properties/padding.ts");
/* harmony import */ var _helpers_properties_margin__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/helpers/properties/margin.ts");
/* harmony import */ var _helpers_properties_web__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/helpers/properties/web.ts");



















const tableElements = ["table", "tbody", "td", "th", "thead", "tr", "tfoot"];
const Box = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function Box2(props, ref) {
  const {
    children,
    display = "flex",
    renderAs,
    backgroundColor,
    cursor,
    id,
    opacity
  } = props;
  let displayValue = display;
  if (renderAs) {
    const type = typeof renderAs === "string" ? renderAs : renderAs.type;
    if (typeof type === "string" && tableElements.includes(type)) {
      displayValue = void 0;
    }
  }
  const animatedStyle = (0,_helpers_animation_useAnimatedProps__WEBPACK_IMPORTED_MODULE_2__.useAnimatedProps)(props, props.animated);
  const getStyles = () => {
    const mediaQueries = {};
    const styles = {
      backgroundColor: backgroundColor ? (0,_helpers_color__WEBPACK_IMPORTED_MODULE_3__.resolveColor)(backgroundColor) : "transparent",
      cursor,
      opacity,
      textDecoration: "none"
    };
    (0,_helpers_properties_web__WEBPACK_IMPORTED_MODULE_4__.mapPropsToWeb)({ display: displayValue }, styles, mediaQueries);
    (0,_helpers_properties_dimension__WEBPACK_IMPORTED_MODULE_5__.mapPropsToDimension)(props, styles, mediaQueries);
    (0,_helpers_properties_flexChild__WEBPACK_IMPORTED_MODULE_6__.mapPropsToFlexChild)(props, styles, mediaQueries);
    (0,_helpers_properties_flexContainer__WEBPACK_IMPORTED_MODULE_7__.mapPropsToFlexContainer)(props, styles, mediaQueries);
    (0,_helpers_properties_margin__WEBPACK_IMPORTED_MODULE_8__.mapPropsToMargin)(props, styles, mediaQueries);
    (0,_helpers_properties_padding__WEBPACK_IMPORTED_MODULE_9__.mapPropsToPadding)(props, styles, mediaQueries);
    (0,_helpers_properties_position__WEBPACK_IMPORTED_MODULE_10__.mapPropsToPosition)(props, styles, mediaQueries);
    (0,_helpers_properties_border__WEBPACK_IMPORTED_MODULE_11__.mapPropsToBorder)(props, styles, mediaQueries);
    (0,_helpers_properties_stacking__WEBPACK_IMPORTED_MODULE_12__.mapPropsToStacking)(props, styles);
    (0,_helpers_properties_visiblyHidden__WEBPACK_IMPORTED_MODULE_13__.mapPropsToVisiblyHidden)(props, styles);
    (0,_helpers_properties_shadow__WEBPACK_IMPORTED_MODULE_14__.mapPropsToShadow)(props, styles);
    (0,_helpers_properties_transforms__WEBPACK_IMPORTED_MODULE_15__.mapPropsToTransforms)(props, styles);
    animatedStyle && Object.assign(styles, animatedStyle);
    Object.assign(styles, mediaQueries);
    return styles;
  };
  const boxProps = {
    children,
    css: getStyles(),
    id,
    ref
  };
  (0,_helpers_properties_testing__WEBPACK_IMPORTED_MODULE_16__.mapPropsToTestingProps)(props, boxProps);
  (0,_helpers_properties_accessibility__WEBPACK_IMPORTED_MODULE_17__.mapPropsToAccessibility)(props, boxProps);
  return (0,_helpers_element__WEBPACK_IMPORTED_MODULE_18__.element)(/* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}), boxProps, renderAs);
});


/***/ }),

/***/ "./src/Code/Code.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Code": () => (/* binding */ Code)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/Typography/Typography.tsx");
/* harmony import */ var _helpers_useToken__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/useToken/index.ts");
/* harmony import */ var _Markdown_helpers_useHasMarkdownContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/Markdown/helpers/useHasMarkdownContext.tsx");





const Code = (props) => {
  const isWithinMarkdownContext = (0,_Markdown_helpers_useHasMarkdownContext__WEBPACK_IMPORTED_MODULE_1__.useHasMarkdownContext)();
  const { typographies } = (0,_helpers_useToken__WEBPACK_IMPORTED_MODULE_2__.useToken)();
  const sizeProps = isWithinMarkdownContext ? {} : typographies["text-80"];
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Typography__WEBPACK_IMPORTED_MODULE_3__.Typography,
    {
      ...props,
      ...sizeProps,
      borderRadius: 4,
      monospace: true,
      paddingX: 6,
      renderAs: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        "code",
        {
          style: {
            color: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_4__.colors.purple300,
            backgroundColor: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_4__.colors.purple20
          }
        }
      )
    }
  );
};


/***/ }),

/***/ "./src/Form/FormContext.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FormManagerProvider": () => (/* binding */ FormManagerProvider),
/* harmony export */   "useField": () => (/* binding */ useField),
/* harmony export */   "useFormContext": () => (/* binding */ useFormContext)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_nodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/nodash/index.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/Form/helpers.ts");




const FormManagerContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  canBeSubmitted: true,
  isSubmitting: false,
  submit: _helpers_nodash__WEBPACK_IMPORTED_MODULE_2__.noop,
  registerField: _helpers_nodash__WEBPACK_IMPORTED_MODULE_2__.noop,
  unregisterField: _helpers_nodash__WEBPACK_IMPORTED_MODULE_2__.noop,
  updateValue: _helpers_nodash__WEBPACK_IMPORTED_MODULE_2__.noop
});
const FormManagerProvider = ({
  children,
  valuesRef,
  canBeSubmitted = true,
  isSubmitting,
  submit
}) => {
  const registerField = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(
    (name, { initialValue, value, validateField }) => {
      valuesRef.current[name] = {
        initialValue,
        value,
        validateField
      };
    },
    [valuesRef]
  );
  const unregisterField = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(
    (name) => {
      delete valuesRef.current[name];
    },
    [valuesRef]
  );
  const updateValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(
    (name, value) => {
      valuesRef.current[name].value = value;
    },
    [valuesRef]
  );
  const providerValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(
    () => ({
      canBeSubmitted,
      isSubmitting,
      submit,
      updateValue,
      registerField,
      unregisterField
    }),
    [
      canBeSubmitted,
      isSubmitting,
      submit,
      updateValue,
      registerField,
      unregisterField
    ]
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormManagerContext.Provider, { value: providerValue, children });
};
const useFormContext = () => {
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(FormManagerContext);
};
const isApplicableFeedback = (state) => {
  return state === true || typeof state === "string" && state !== "";
};
const getValidationObject = ({
  error,
  warning
}) => {
  if (isApplicableFeedback(error)) {
    const errorObj = {
      type: "error"
    };
    if (typeof error === "string") {
      errorObj.message = error;
    }
    return errorObj;
  }
  if (isApplicableFeedback(warning)) {
    const warningObj = {
      type: "warning"
    };
    if (typeof warning === "string") {
      warningObj.message = warning;
    }
    return warningObj;
  }
  return void 0;
};
const useField = (name, {
  initialValue,
  value: valueProp,
  onChange: onChangeProp,
  onFocusChange: onFocusChangeProp,
  onValidation,
  error: errorProp,
  warning: warningProp
}) => {
  const { updateValue, registerField, unregisterField } = useFormContext();
  const [value, setValueState] = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__.useControllableState)({
    initialState: initialValue,
    stateProp: valueProp
  });
  const validationObjectFromProp = getValidationObject({
    error: errorProp,
    warning: warningProp
  });
  const [validationState, setValidationState] = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__.useControllableState)({
    initialState: void 0,
    stateProp: validationObjectFromProp
  });
  const validateField = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(
    (valueParam) => {
      if (validationObjectFromProp?.type !== void 0) {
        return validationObjectFromProp.type;
      }
      const validationFeedback = onValidation?.(valueParam);
      let validationType = "none";
      if (typeof validationFeedback === "string") {
        setValidationState({
          type: "error",
          message: validationFeedback
        });
        validationType = "error";
      } else if (typeof validationFeedback === "object") {
        setValidationState(validationFeedback);
        validationType = validationFeedback.type;
      } else {
        setValidationState(void 0);
      }
      return validationType;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onValidation, setValidationState]
  );
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (name === void 0) {
      return;
    }
    registerField(name, { initialValue, value, validateField });
    return () => unregisterField(name);
  }, [name]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (name !== void 0) {
      updateValue(name, value);
    }
  }, [updateValue, name, value]);
  const hadValidationFeedbackRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(validationState !== void 0);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (validationState !== void 0) {
      hadValidationFeedbackRef.current = true;
    }
  }, [validationState]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (hadValidationFeedbackRef.current) {
      validateField(value);
    }
  }, [value]);
  const error = validationState?.type === "error" ? validationState.message || true : void 0;
  const warning = validationState?.type === "warning" ? validationState.message || true : void 0;
  const handleChange = (nextValue) => {
    setValueState(nextValue);
    onChangeProp?.(nextValue);
  };
  const handleFocusChange = (isFocused) => {
    onFocusChangeProp?.(isFocused);
    if (isFocused) {
      return;
    }
    validateField(value);
  };
  return {
    value,
    onChange: handleChange,
    onFocusChange: handleFocusChange,
    error,
    warning
  };
};


/***/ }),

/***/ "./src/Form/helpers.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useControllableState": () => (/* binding */ useControllableState)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const useControllableState = ({
  initialState,
  stateProp
}) => {
  const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState);
  const returnedState = stateProp !== void 0 ? stateProp : state;
  const returnedSetState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (nextState) => {
      if (stateProp !== void 0) {
        return;
      }
      if (state === nextState) {
        return;
      }
      setState(nextState);
    },
    [state, stateProp]
  );
  return [returnedState, returnedSetState];
};


/***/ }),

/***/ "./src/Heading/Heading.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Heading": () => (/* binding */ Heading)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Typography/Typography.tsx");
/* harmony import */ var _helpers_useToken__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useToken/index.ts");
/* harmony import */ var _Text_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/Text/helpers.ts");




const sizeToLevelMap = {
  "text-700": "1",
  "text-600": "2",
  "text-500": "3",
  "text-400": "4",
  "text-300": "5"
};
const Heading = ({
  color = "navy200",
  size = "text-300",
  level = sizeToLevelMap[size],
  children,
  ...props
}) => {
  const { typographies } = (0,_helpers_useToken__WEBPACK_IMPORTED_MODULE_1__.useToken)();
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Typography__WEBPACK_IMPORTED_MODULE_2__.Typography,
    {
      ...(0,_Text_helpers__WEBPACK_IMPORTED_MODULE_3__.mapUtilityToTypographyProps)(props),
      ...typographies[size],
      color,
      fontVariation: "bold",
      renderAs: `h${level}`,
      ...props,
      children
    }
  );
};


/***/ }),

/***/ "./src/Link/Link.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Link": () => (/* binding */ Link)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Linkable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/Linkable/Linkable.tsx");
/* harmony import */ var _LinkText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/LinkText/LinkText.tsx");




const Link = ({
  children,
  href,
  id,
  isNewWindow,
  margin,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  marginX,
  marginY,
  onAction,
  renderAs,
  testId,
  ...restProps
}) => {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Linkable__WEBPACK_IMPORTED_MODULE_1__.Linkable,
    {
      borderRadius: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_2__.radii.medium,
      display: "inline-flex",
      href,
      id,
      isNewWindow,
      margin,
      marginBottom,
      marginLeft,
      marginRight,
      marginTop,
      marginX,
      marginY,
      onAction,
      renderAs,
      testId,
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LinkText__WEBPACK_IMPORTED_MODULE_3__.LinkElement, { ...restProps, children })
    }
  );
};


/***/ }),

/***/ "./src/LinkText/LinkText.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LinkElement": () => (/* binding */ LinkElement),
/* harmony export */   "LinkText": () => (/* binding */ LinkText)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/Typography/Typography.tsx");
/* harmony import */ var _helpers_animation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/helpers/animation/helpers.ts");
/* harmony import */ var _helpers_useToken__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/useToken/index.ts");
/* harmony import */ var _Markdown_helpers_useHasMarkdownContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Markdown/helpers/useHasMarkdownContext.tsx");
/* harmony import */ var _helpers_useWarning__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useWarning/index.ts");






const LinkText = (props) => {
  (0,_helpers_useWarning__WEBPACK_IMPORTED_MODULE_1__.useWarning)([
    "LinkText",
    "is deprecated and will be removed in a future version. Use the `Link` component instead: https://midnight.payfit.tech/components/link"
  ]);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkElement, { ...props });
};
const LinkElement = (props) => {
  const isWithinMarkdownContext = (0,_Markdown_helpers_useHasMarkdownContext__WEBPACK_IMPORTED_MODULE_2__.useHasMarkdownContext)();
  const { typographies } = (0,_helpers_useToken__WEBPACK_IMPORTED_MODULE_3__.useToken)();
  const sizeProps = isWithinMarkdownContext ? {} : typographies["text-100"];
  const animated = (0,_helpers_animation__WEBPACK_IMPORTED_MODULE_4__.transition)("opacity", 200, "linear");
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Typography__WEBPACK_IMPORTED_MODULE_5__.Typography,
    {
      ...sizeProps,
      animated,
      color: "blue100",
      textDecoration: "none",
      fontVariation: "bold",
      ...props
    }
  );
};


/***/ }),

/***/ "./src/Linkable/Linkable.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Linkable": () => (/* binding */ Linkable)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _payfit_midnight_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("@payfit/midnight-utils");
/* harmony import */ var _payfit_midnight_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Actionable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/Actionable/Actionable.tsx");
/* harmony import */ var _helpers_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/helpers/element/element.ts");
/* harmony import */ var _helpers_useAction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/Linkable/helpers/useAction/index.ts");
/* harmony import */ var _helpers_useIsSafeURL__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Linkable/helpers/useIsSafeURL.ts");






const Linkable = ({
  children,
  href,
  isNewWindow,
  onAction,
  renderAs,
  htmlAttributes,
  ...restProps
}) => {
  const isSafeUrl = (0,_helpers_useIsSafeURL__WEBPACK_IMPORTED_MODULE_2__.useIsSafeURL)(href);
  const LinkComponent = (0,_payfit_midnight_utils__WEBPACK_IMPORTED_MODULE_1__.useLinkComponent)();
  const handleAction = (0,_helpers_useAction__WEBPACK_IMPORTED_MODULE_3__.useAction)({ href, onAction });
  const newWindowProps = isNewWindow ? {
    rel: "noopener noreferrer",
    target: "_blank"
  } : {};
  const linkElement = (0,_helpers_element__WEBPACK_IMPORTED_MODULE_4__.element)(
    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkComponent, {}),
    {
      ...htmlAttributes,
      ...newWindowProps,
      children,
      href: isSafeUrl ? href : void 0
    },
    renderAs
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Actionable__WEBPACK_IMPORTED_MODULE_5__.Actionable,
    {
      ...restProps,
      accessibilityRole: "link",
      onAction: handleAction,
      renderAs: linkElement,
      children
    }
  );
};


/***/ }),

/***/ "./src/Linkable/helpers/useAction/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useAction": () => (/* binding */ useAction)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const useAction = ({ onAction }) => {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    (event) => {
      if (typeof onAction === "function") {
        onAction(event);
      }
    },
    [onAction]
  );
};


/***/ }),

/***/ "./src/Linkable/helpers/useIsSafeURL.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useIsSafeURL": () => (/* binding */ useIsSafeURL)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_useWarning__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useWarning/index.ts");


const isJavaScriptProtocol = (
  // eslint-disable-next-line no-control-regex
  /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i
);
const isSafeURL = (link) => {
  return !isJavaScriptProtocol.test(link);
};
const useIsSafeURL = (link) => {
  const isSafe = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => isSafeURL(link), [link]);
  (0,_helpers_useWarning__WEBPACK_IMPORTED_MODULE_1__.useWarning)(["Link", `Unsupported URL ${JSON.stringify(link)}`], !isSafe);
  return isSafe;
};


/***/ }),

/***/ "./src/Markdown/Markdown.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Markdown": () => (/* binding */ Markdown)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/Link/Link.tsx");
/* harmony import */ var _Code__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/Code/Code.tsx");
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/Heading/Heading.tsx");
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/Text/Text.tsx");
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/Typography/Typography.tsx");
/* harmony import */ var _helpers_compiler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Markdown/helpers/compiler/compiler.ts");
/* harmony import */ var _components_Block__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/Markdown/components/Block/index.tsx");
/* harmony import */ var _components_ListItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/Markdown/components/ListItem/index.tsx");
/* harmony import */ var _helpers_useHasMarkdownContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/Markdown/helpers/useHasMarkdownContext.tsx");











const Markdown = (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function Markdown2({
  children,
  color,
  isInline,
  ...restProps
}) {
  if (typeof children !== "string" && children !== void 0) {
    return children;
  }
  if (children === void 0) {
    return null;
  }
  const transformedChildren = !isInline ? children : (
    // @note: in case of inline mode, we strip all beginning block creation characters and linebreaks
    children.replace(/^(?:#+|\d\.|[*+-]\s)/gi, "").replace(/\n/gi, " ")
  );
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(
    react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
    null,
    (0,_helpers_compiler__WEBPACK_IMPORTED_MODULE_2__.compile)(transformedChildren, {
      // @note: we use div as root container and not the semantic `<p />` element
      // to avoid invalid html such as root containing nested headers
      // The same logic has been applied for the paragraph element renderer
      root(content, key) {
        return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_helpers_useHasMarkdownContext__WEBPACK_IMPORTED_MODULE_3__.HasMarkdownContextProvider, { value: true, children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          _Text__WEBPACK_IMPORTED_MODULE_4__.Text,
          {
            ...restProps,
            color,
            renderAs: isInline ? "span" : "div",
            children: content
          },
          key
        ) });
      },
      emphasis(content, key, { variation }) {
        switch (variation) {
          case "italic":
            return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_5__.Typography, { fontVariation: "italic", children: content }, key);
          case "strikethrough":
            return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_5__.Typography, { textDecoration: "line-through", children: content }, key);
          case "underline":
            return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_5__.Typography, { textDecoration: "underline", children: content }, key);
          case "bold":
          default:
            return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
              _Typography__WEBPACK_IMPORTED_MODULE_5__.Typography,
              {
                fontVariation: "bold",
                color: !color || String(color).startsWith("navy") ? "navy200" : void 0,
                children: content
              },
              key
            );
        }
      },
      paragraph(content, key) {
        return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Block__WEBPACK_IMPORTED_MODULE_6__.MarkdownBlock, { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_5__.Typography, { renderAs: "div", children: content }) }, key);
      },
      heading(content, key, { level }) {
        const midnightLevel = String(Math.min(level, 5));
        const sizeByLevel = {
          "1": "text-700",
          "2": "text-600",
          "3": "text-500",
          "4": "text-400",
          "5": "text-300"
        };
        return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Block__WEBPACK_IMPORTED_MODULE_6__.MarkdownBlock, { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_7__.Heading, { marginY: "spacing-100", size: sizeByLevel[midnightLevel], children: content }) }, key);
      },
      code(content, key) {
        return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Code__WEBPACK_IMPORTED_MODULE_8__.Code, { children: content }, key);
      },
      link(content, key, { href }) {
        return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_9__.Link, { href, children: content }, key);
      },
      list(content, key, { variation }) {
        return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          _Typography__WEBPACK_IMPORTED_MODULE_5__.Typography,
          {
            marginY: "spacing-80",
            renderAs: variation === "ordered" ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {}) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {}),
            children: content
          },
          key
        );
      },
      listItem(content, key, { index }) {
        return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Block__WEBPACK_IMPORTED_MODULE_6__.MarkdownBlock, { children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ListItem__WEBPACK_IMPORTED_MODULE_10__.MarkdownListItem, { index, children: content }) }, key);
      }
    })
  );
});


/***/ }),

/***/ "./src/Markdown/components/Block/index.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MarkdownBlock": () => (/* binding */ MarkdownBlock)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);

const MarkdownBlock = ({ children }) => {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children });
};


/***/ }),

/***/ "./src/Markdown/components/ListItem/index.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MarkdownListItem": () => (/* binding */ MarkdownListItem)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/Typography/Typography.tsx");


const MarkdownListItem = ({
  index,
  ...restProps
}) => {
  const isOrdered = typeof index === "number";
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Typography__WEBPACK_IMPORTED_MODULE_1__.Typography,
    {
      ...restProps,
      marginLeft: "spacing-300",
      renderAs: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        "li",
        {
          style: {
            display: "list-item",
            listStyle: isOrdered ? "decimal" : "disc"
          }
        }
      )
    }
  );
};


/***/ }),

/***/ "./src/Markdown/helpers/compiler/compiler.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "compile": () => (/* binding */ compile)
/* harmony export */ });
/* harmony import */ var _parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/Markdown/helpers/compiler/parser.ts");
/* harmony import */ var _renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/Markdown/helpers/compiler/renderer.ts");


const compile = (content, renderer) => {
  const ast = (0,_parser__WEBPACK_IMPORTED_MODULE_0__.parse)(content);
  return (0,_renderer__WEBPACK_IMPORTED_MODULE_1__.render)(renderer, ast);
};


/***/ }),

/***/ "./src/Markdown/helpers/compiler/parser.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "parse": () => (/* binding */ parse)
/* harmony export */ });
/* harmony import */ var _token__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/Markdown/helpers/compiler/token.ts");

const parse = (content) => {
  const tokenizer = /^(?:((?!#+|\d+\.\s|[*+-]\s).+(?:\n(?!#+|\d+\.\s|[*+-]\s).+)*)|(#+)\s*(.*)|\d+\.\s+(.*)|(?:[*+-])\s+(.*))$/gm;
  let match = null;
  const ast = [];
  let currentListToken = null;
  while ((match = tokenizer.exec(content)) !== null) {
    const [, ...matchedGroups] = match;
    const namedGroups = {
      paragraph: matchedGroups[0],
      headingLevel: matchedGroups[1],
      heading: matchedGroups[2],
      listOrdered: matchedGroups[3],
      listUnordered: matchedGroups[4]
    };
    if (namedGroups.paragraph) {
      const paragraphs = namedGroups.paragraph.split(/\s{2}\n/);
      for (const paragraph of paragraphs) {
        ast.push(
          (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("paragraph", {
            children: parseInline(paragraph.split("\n").join(" "))
          })
        );
      }
    }
    if (namedGroups.heading && namedGroups.headingLevel) {
      ast.push(
        (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("heading", {
          children: parseInline(namedGroups.heading),
          attributes: {
            level: Math.min(
              namedGroups.headingLevel.length,
              6
            )
          }
        })
      );
    }
    const listContent = namedGroups.listOrdered || namedGroups.listUnordered;
    if (listContent) {
      const isOrdered = Boolean(namedGroups.listOrdered);
      const variation = isOrdered ? "ordered" : "unordered";
      const listItemToken = (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("listItem", {
        children: parseInline(listContent),
        attributes: {
          index: isOrdered ? 0 : void 0
        }
      });
      if (currentListToken?.type === "list" && currentListToken.attributes.variation === variation) {
        listItemToken.attributes.index = isOrdered ? currentListToken.children.length : void 0;
        currentListToken.children.push(listItemToken);
      } else {
        currentListToken = (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("list", {
          children: [listItemToken],
          attributes: { variation }
        });
        ast.push(currentListToken);
      }
    } else {
      currentListToken = null;
    }
  }
  const children = ast.length === 1 && ast[0].type === "paragraph" ? ast[0].children : ast;
  return (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("root", { children });
};
const parseInline = (content) => {
  const tokenizer = /[*]{2}([^*]+)[*]{2}|[*]{2}(.+)[*]{2}|[*]([^*]+)[*]|[_]([^_]+)[_]|[_]{2}([^_]+)[_]{2}|[_]{2}(.+)[_]{2}|~{2}([^~]+)~{2}|~{2}(.+)~{2}|`(.+)`|\[(.+?)\]\((.+?)\)/gm;
  let match = null;
  let lastIndex = 0;
  const tokens = [];
  while ((match = tokenizer.exec(content)) !== null) {
    addTextToken(match.index);
    const [, ...matchedGroups] = match;
    const namedGroups = {
      emphasisBold: matchedGroups[0] || matchedGroups[1],
      emphasisItalic: matchedGroups[2] || matchedGroups[3],
      emphasisUnderline: matchedGroups[4] || matchedGroups[5],
      emphasisStrikethrough: matchedGroups[6] || matchedGroups[7],
      code: matchedGroups[8],
      link: matchedGroups[9],
      linkHref: matchedGroups[10]
    };
    const token = getInlineToken(namedGroups);
    if (token) {
      tokens.push(token);
    }
  }
  addTextToken();
  function addTextToken(indexEnd) {
    const chunk = content.substring(lastIndex, indexEnd);
    if (chunk) {
      tokens.push((0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("text", { children: [chunk] }));
    }
    lastIndex = tokenizer.lastIndex;
  }
  return tokens;
};
const getInlineToken = (values) => {
  if (values.link && values.linkHref) {
    return (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("link", {
      children: parseInline(values.link),
      attributes: {
        href: values.linkHref
      }
    });
  }
  if (values.emphasisBold) {
    return (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("emphasis", {
      children: parseInline(values.emphasisBold),
      attributes: {
        variation: "bold"
      }
    });
  }
  if (values.emphasisItalic) {
    return (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("emphasis", {
      children: parseInline(values.emphasisItalic),
      attributes: {
        variation: "italic"
      }
    });
  }
  if (values.emphasisStrikethrough) {
    return (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("emphasis", {
      children: parseInline(values.emphasisStrikethrough),
      attributes: {
        variation: "strikethrough"
      }
    });
  }
  if (values.emphasisUnderline) {
    return (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("emphasis", {
      children: parseInline(values.emphasisUnderline),
      attributes: {
        variation: "underline"
      }
    });
  }
  if (values.code) {
    return (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("code", { children: parseInline(values.code) });
  }
  if (values.text) {
    return (0,_token__WEBPACK_IMPORTED_MODULE_0__.createToken)("text", {
      children: parseInline(values.text)
    });
  }
  return null;
};


/***/ }),

/***/ "./src/Markdown/helpers/compiler/renderer.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "render": () => (/* binding */ render)
/* harmony export */ });
const render = (renderer, ast) => {
  const renderToElement = renderer[ast.type];
  const key = createKey(0);
  return renderToElement(
    renderTokens(renderer, ast.children, key),
    key,
    void 0
  );
};
const renderTokens = (renderer, ast, parentKey) => {
  const output = [];
  for (let nodeIndex = 0; nodeIndex < ast.length; nodeIndex++) {
    const tokenNode = ast[nodeIndex];
    if (tokenNode.type !== "text") {
      const renderToElement = renderer[tokenNode.type];
      const key = createKey(nodeIndex, parentKey);
      output.push(
        renderToElement(
          renderTokens(renderer, tokenNode.children, key),
          key,
          "attributes" in tokenNode ? tokenNode.attributes : void 0
        )
      );
    } else {
      output.push(tokenNode.children[0]);
    }
  }
  return output;
};
const createKey = (index, parentKey = "") => `${parentKey}${parentKey ? "-" : ""}${index}`;


/***/ }),

/***/ "./src/Markdown/helpers/compiler/token.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createToken": () => (/* binding */ createToken)
/* harmony export */ });
const createToken = (type, args) => {
  return {
    type,
    ...args
  };
};


/***/ }),

/***/ "./src/Markdown/helpers/useHasMarkdownContext.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HasMarkdownContextProvider": () => (/* binding */ HasMarkdownContextProvider),
/* harmony export */   "useHasMarkdownContext": () => (/* binding */ useHasMarkdownContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const HasMarkdownContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);
const HasMarkdownContextProvider = HasMarkdownContext.Provider;
const useHasMarkdownContext = () => {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HasMarkdownContext);
};


/***/ }),

/***/ "./src/SelectableInput/SelectableInput.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SelectableInput": () => (/* binding */ SelectableInput)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_useAccessibilityListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/useAccessibilityListener/useAccessibilityListener.tsx");
/* harmony import */ var _helpers_useId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/useId/index.ts");
/* harmony import */ var _components_Content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/SelectableInput/components/Content/index.tsx");





const SelectableInput = (props) => {
  const { id: idProp, isDisabled, onChange, value, ...restProps } = props;
  const { getFocusRingVisibility } = (0,_helpers_useAccessibilityListener__WEBPACK_IMPORTED_MODULE_2__.useAccessibilityListener)();
  const [isFocused, setIsFocused] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const [isHovered, setIsHovered] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const renderElement = props.isCustomView ? props.renderView : props.renderControl;
  const children = renderElement({
    isFocused: isFocused && getFocusRingVisibility(),
    isHovered: isHovered && !isDisabled
  });
  const id = (0,_helpers_useId__WEBPACK_IMPORTED_MODULE_3__.useId)(idProp);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _components_Content__WEBPACK_IMPORTED_MODULE_4__.SelectableInputContent,
    {
      ...restProps,
      isCustomView: props.isCustomView,
      accessibilityChecked: value === "indeterminate" ? "mixed" : value,
      id,
      isDisabled,
      onChange: () => {
        onChange(value === "indeterminate" ? true : !value);
      },
      onFocusChange: setIsFocused,
      onHoverChange: setIsHovered,
      value,
      children
    }
  );
};


/***/ }),

/***/ "./src/SelectableInput/components/Content/index.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SelectableInputContent": () => (/* binding */ SelectableInputContent)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Box/Box.tsx");
/* harmony import */ var _helpers_useToken__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useToken/index.ts");
/* harmony import */ var _Label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/SelectableInput/components/Label.tsx");




const mapRoleToType = (accessibilityRole) => {
  switch (accessibilityRole) {
    case "checkbox":
    case "switch":
      return "checkbox";
    default:
      return accessibilityRole;
  }
};
const SelectableInputContent = (props) => {
  const {
    accessibilityChecked,
    accessibilityRole,
    children,
    errorId,
    hideLabel,
    id,
    isCustomView,
    isDisabled,
    label,
    name,
    onChange,
    onFocusChange,
    onHoverChange,
    value,
    ...restProps
  } = props;
  const { spacings } = (0,_helpers_useToken__WEBPACK_IMPORTED_MODULE_1__.useToken)();
  const cursor = isDisabled ? "not-allowed" : "pointer";
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(
    _Box__WEBPACK_IMPORTED_MODULE_2__.Box,
    {
      ...restProps,
      alignItems: "stretch",
      cursor,
      direction: "row",
      renderAs: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        "label",
        {
          htmlFor: id,
          onFocus: () => onFocusChange(true),
          onBlur: () => onFocusChange(false),
          onPointerEnter: () => onHoverChange(true),
          onPointerLeave: () => onHoverChange(false),
          style: {
            userSelect: "none"
          }
        }
      ),
      children: [
        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_2__.Box, { position: "relative", width: isCustomView ? "100%" : void 0, children: [
          /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
            _Box__WEBPACK_IMPORTED_MODULE_2__.Box,
            {
              accessibilityChecked,
              cursor,
              id,
              position: "absolute",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              opacity: 1e-3,
              renderAs: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
                "input",
                {
                  type: mapRoleToType(accessibilityRole),
                  role: accessibilityRole,
                  "aria-errormessage": errorId,
                  "aria-invalid": errorId ? true : void 0,
                  name,
                  checked: Boolean(value),
                  onChange,
                  disabled: isDisabled
                }
              )
            }
          ),
          children
        ] }),
        !isCustomView && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
          _Label__WEBPACK_IMPORTED_MODULE_3__.Label,
          {
            isDisabled,
            marginLeft: !hideLabel ? spacings["spacing-60"] : void 0,
            visiblyHidden: hideLabel,
            withMarkdown: true,
            children: label
          }
        )
      ]
    }
  );
};


/***/ }),

/***/ "./src/SelectableInput/components/Label.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Label": () => (/* binding */ Label)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Text/Text.tsx");
/* harmony import */ var _Markdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/Markdown/Markdown.tsx");



const Label = ({
  isDisabled,
  children,
  visiblyHidden,
  withMarkdown,
  ...props
}) => {
  const commonProps = {
    color: isDisabled ? "navy20" : void 0,
    visiblyHidden
  };
  if (withMarkdown && typeof children === "string") {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Markdown__WEBPACK_IMPORTED_MODULE_1__.Markdown, { isInline: true, ...commonProps, ...props, children });
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_2__.Text, { ...commonProps, ...props, children });
};


/***/ }),

/***/ "./src/Switch/Switch.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Switch": () => (/* binding */ Switch)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Form_FormContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/Form/FormContext.tsx");
/* harmony import */ var _SelectableInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/SelectableInput/SelectableInput.tsx");
/* harmony import */ var _components_SwitchElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/Switch/components/SwitchElement.tsx");




const Switch = ({
  hideLabel,
  id,
  initialValue = false,
  isDisabled: isDisabledInput,
  label,
  name,
  onChange: onChangeProp,
  value: valueProp,
  ...restProps
}) => {
  const { value, onChange } = (0,_Form_FormContext__WEBPACK_IMPORTED_MODULE_1__.useField)(name, {
    initialValue,
    value: valueProp,
    onChange: onChangeProp
  });
  const formContext = (0,_Form_FormContext__WEBPACK_IMPORTED_MODULE_1__.useFormContext)();
  const isDisabled = formContext.isSubmitting || isDisabledInput;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _SelectableInput__WEBPACK_IMPORTED_MODULE_2__.SelectableInput,
    {
      ...restProps,
      accessibilityRole: "switch",
      hideLabel,
      id,
      isDisabled,
      label,
      minHeight: 22,
      name,
      onChange,
      value,
      renderControl: ({ isFocused, isHovered }) => /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        _components_SwitchElement__WEBPACK_IMPORTED_MODULE_3__.SwitchElement,
        {
          marginTop: 2,
          isDisabled,
          isFocused,
          isHovered,
          isSelected: value
        }
      )
    }
  );
};


/***/ }),

/***/ "./src/Switch/components/SwitchElement.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SwitchElement": () => (/* binding */ SwitchElement)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_animation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/animation/helpers.ts");
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/Box/Box.tsx");



const getTrackBackgroundColor = ({
  isDisabled,
  isHovered,
  isSelected
}) => {
  if (isDisabled) {
    return isSelected ? "blue40" : "silver80";
  }
  if (isHovered) {
    return isSelected ? "blue80" : "silver100";
  }
  return isSelected ? "blue100" : "silver200";
};
const TOGGLE_SIZE = 14;
const TRACK_WIDTH = 32;
const SwitchElement = ({
  isDisabled,
  isFocused,
  isHovered,
  isSelected,
  ...restProps
}) => {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Box__WEBPACK_IMPORTED_MODULE_1__.Box,
    {
      ...restProps,
      accessibilityHidden: true,
      flexShrink: 0,
      height: 18,
      width: TRACK_WIDTH,
      borderRadius: TRACK_WIDTH,
      padding: 2,
      backgroundColor: getTrackBackgroundColor({
        isDisabled,
        isHovered,
        isSelected
      }),
      animated: (0,_helpers_animation__WEBPACK_IMPORTED_MODULE_2__.transition)("backgroundColor", 200, "linear"),
      withOutline: isFocused,
      renderAs: "span",
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        _Box__WEBPACK_IMPORTED_MODULE_1__.Box,
        {
          shadow: "shadow-100",
          borderRadius: TOGGLE_SIZE,
          width: TOGGLE_SIZE,
          height: TOGGLE_SIZE,
          backgroundColor: isDisabled ? "silver40" : "white",
          transform: isSelected ? [{ translateX: TOGGLE_SIZE }] : void 0,
          animated: (0,_helpers_animation__WEBPACK_IMPORTED_MODULE_2__.transition)("transform.translateX", 100, "linear")
        }
      )
    }
  );
};


/***/ }),

/***/ "./src/Text/Text.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Text": () => (/* binding */ Text)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/Typography/Typography.tsx");
/* harmony import */ var _helpers_useToken__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useToken/index.ts");
/* harmony import */ var _helpers_useWarning__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/useWarning/index.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Text/helpers.ts");





const Text = ({
  color: colorProp,
  hasLineThrough,
  isCapitalized,
  size = "text-100",
  variation,
  ...restProps
}) => {
  const { typographies } = (0,_helpers_useToken__WEBPACK_IMPORTED_MODULE_1__.useToken)();
  const sizeProps = typographies[size];
  const variationProps = mapVariationPropsToTypographyProps(variation);
  const fontVariation = variationProps.fontVariation || sizeProps.fontVariation;
  const utilityProps = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__.mapUtilityToTypographyProps)({
    isCapitalized
  });
  const color = colorProp ? colorProp : fontVariation === "bold" ? "navy200" : "navy80";
  (0,_helpers_useWarning__WEBPACK_IMPORTED_MODULE_3__.useWarning)(
    [
      "Text",
      `${size} is deprecated. Please use the corresponding \`variation\` prop`
    ],
    Boolean(size && ["text-100-medium", "text-60-caps"].includes(size))
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    _Typography__WEBPACK_IMPORTED_MODULE_4__.Typography,
    {
      ...restProps,
      color,
      fontSize: sizeProps.fontSize,
      fontVariation,
      fontWeight: variationProps.fontWeight || sizeProps.fontWeight,
      textDecoration: hasLineThrough ? "line-through" : void 0,
      textTransform: variationProps.textTransform || utilityProps.textTransform || sizeProps.textTransform
    }
  );
};
const mapVariationPropsToTypographyProps = (variation) => {
  switch (variation) {
    case "bold":
      return {
        fontVariation: "bold"
      };
    case "normal":
      return {
        fontVariation: "normal"
      };
    case "caps":
      return {
        textTransform: "uppercase",
        fontWeight: 600
      };
    default:
      return {};
  }
};


/***/ }),

/***/ "./src/Text/helpers.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapUtilityToTypographyProps": () => (/* binding */ mapUtilityToTypographyProps)
/* harmony export */ });
const mapUtilityToTypographyProps = ({
  isCapitalized
}) => {
  return {
    textTransform: isCapitalized ? "capitalize" : void 0
  };
};


/***/ }),

/***/ "./src/Typography/Typography.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Typography": () => (/* binding */ Typography)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react/jsx-runtime");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/color/index.ts");
/* harmony import */ var _helpers_element__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("./src/helpers/element/element.ts");
/* harmony import */ var _helpers_animation_useAnimatedProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/animation/useAnimatedProps.ts");
/* harmony import */ var _helpers_properties_accessibility__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./src/helpers/properties/accessibility.ts");
/* harmony import */ var _helpers_properties_margin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/helpers/properties/margin.ts");
/* harmony import */ var _helpers_properties_padding__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/helpers/properties/padding.ts");
/* harmony import */ var _helpers_properties_position__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/helpers/properties/position.ts");
/* harmony import */ var _helpers_properties_border__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/helpers/properties/border.ts");
/* harmony import */ var _helpers_properties_visiblyHidden__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/helpers/properties/visiblyHidden/visiblyHidden.ts");
/* harmony import */ var _helpers_properties_testing__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./src/helpers/properties/testing.ts");
/* harmony import */ var _helpers_properties_transforms__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/helpers/properties/transforms.ts");
/* harmony import */ var _helpers_properties_stacking__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/helpers/properties/stacking.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/Typography/helpers.ts");














const Typography = (props) => {
  const {
    children,
    color,
    renderAs,
    backgroundColor,
    fontSize,
    fontVariation,
    fontWeight,
    id,
    letterSpacing,
    lineHeight,
    opacity,
    textAlign,
    textDecoration,
    textTransform
  } = props;
  const animatedStyle = (0,_helpers_animation_useAnimatedProps__WEBPACK_IMPORTED_MODULE_1__.useAnimatedProps)(props, props.animated);
  const lineHeightValue = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__.getLineHeight)({ lineHeight, fontSize });
  const getStyles = () => {
    const mediaQueries = {};
    const styles = {
      backgroundColor: backgroundColor && (0,_helpers_color__WEBPACK_IMPORTED_MODULE_3__.resolveColor)(backgroundColor),
      color: color && (0,_helpers_color__WEBPACK_IMPORTED_MODULE_3__.resolveColor)(color),
      fontSize,
      fontStyle: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__.getFontStyle)({ fontVariation }),
      fontWeight: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__.getFontWeight)({ fontVariation, fontWeight }),
      letterSpacing,
      lineHeight: lineHeightValue ? `${lineHeightValue}px` : void 0,
      opacity,
      textAlign,
      textDecoration,
      textTransform
    };
    (0,_helpers_properties_margin__WEBPACK_IMPORTED_MODULE_4__.mapPropsToMargin)(props, styles, mediaQueries);
    (0,_helpers_properties_padding__WEBPACK_IMPORTED_MODULE_5__.mapPropsToPadding)(props, styles, mediaQueries);
    (0,_helpers_properties_position__WEBPACK_IMPORTED_MODULE_6__.mapPropsToPosition)(props, styles, mediaQueries);
    (0,_helpers_properties_border__WEBPACK_IMPORTED_MODULE_7__.mapPropsToBorder)(props, styles, mediaQueries);
    mapPropsToEllipsis(props, styles);
    mapPropsToOverflow(props, styles);
    (0,_helpers_properties_stacking__WEBPACK_IMPORTED_MODULE_8__.mapPropsToStacking)(props, styles);
    (0,_helpers_properties_visiblyHidden__WEBPACK_IMPORTED_MODULE_9__.mapPropsToVisiblyHidden)(props, styles);
    (0,_helpers_properties_transforms__WEBPACK_IMPORTED_MODULE_10__.mapPropsToTransforms)(props, styles);
    animatedStyle && Object.assign(styles, animatedStyle);
    Object.assign(styles, mediaQueries);
    return styles;
  };
  const textProps = {
    children,
    css: getStyles(),
    id
  };
  (0,_helpers_properties_accessibility__WEBPACK_IMPORTED_MODULE_11__.mapPropsToAccessibility)(props, textProps);
  (0,_helpers_properties_testing__WEBPACK_IMPORTED_MODULE_12__.mapPropsToTestingProps)(props, textProps);
  return (0,_helpers_element__WEBPACK_IMPORTED_MODULE_13__.element)(
    getRenderAsElement({
      fontVariation,
      textDecoration
    }),
    textProps,
    renderAs
  );
};
const mapPropsToEllipsis = ({ hasEllipsis, whiteSpace }, style) => {
  style.whiteSpace = whiteSpace;
  if (hasEllipsis) {
    style.overflow = "hidden";
    style.textOverflow = "ellipsis";
    style.whiteSpace = "nowrap";
  }
};
const mapPropsToOverflow = ({ withWrapping }, style) => {
  if (withWrapping) {
    style.wordBreak = "break-word";
  }
};
const getRenderAsElement = ({
  fontVariation,
  textDecoration
}) => {
  switch (true) {
    case fontVariation === "bold":
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {});
    case fontVariation === "italic":
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {});
    case textDecoration === "line-through":
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("del", {});
    case textDecoration === "underline":
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {});
    default:
      return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {});
  }
};


/***/ }),

/***/ "./src/Typography/helpers.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getFontStyle": () => (/* binding */ getFontStyle),
/* harmony export */   "getFontWeight": () => (/* binding */ getFontWeight),
/* harmony export */   "getLineHeight": () => (/* binding */ getLineHeight),
/* harmony export */   "getLineHeightRatio": () => (/* binding */ getLineHeightRatio)
/* harmony export */ });
const getLineHeight = ({
  fontSize,
  lineHeight
}) => {
  if (lineHeight) {
    return lineHeight;
  }
  if (!fontSize) {
    return void 0;
  }
  return Math.round(fontSize * getLineHeightRatio(fontSize));
};
const getLineHeightRatio = (fontSize) => {
  return fontSize >= 20 ? 1.4 : 1.55;
};
const getFontWeight = ({
  fontWeight,
  fontVariation
}) => {
  if (fontWeight) {
    return fontWeight;
  }
  switch (fontVariation) {
    case "bold":
      return 500;
    case "italic":
    case "normal":
      return 400;
    default:
      return void 0;
  }
};
const getFontStyle = ({
  fontVariation
}) => {
  if (fontVariation === "bold") {
    return void 0;
  }
  return fontVariation;
};


/***/ }),

/***/ "./src/helpers/animation/helpers.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bezier": () => (/* binding */ bezier),
/* harmony export */   "isSpinningAnimation": () => (/* binding */ isSpinningAnimation),
/* harmony export */   "isTransition": () => (/* binding */ isTransition),
/* harmony export */   "spin": () => (/* binding */ spin),
/* harmony export */   "transition": () => (/* binding */ transition)
/* harmony export */ });
const isTransition = (animatedProp) => animatedProp.type === "transition";
const isSpinningAnimation = (animatedProp) => animatedProp.type === "spin";
const bezier = (x1, y1, x2, y2) => ({
  x1,
  x2,
  y1,
  y2
});
const transition = (propNames, duration, timingFunction, delay) => ({
  delay,
  duration,
  propNames: Array.isArray(propNames) ? propNames : [propNames],
  timingFunction,
  type: "transition"
});
const spin = (revolutionDuration, timingFunction = "linear", iterations) => ({
  iterations,
  revolutionDuration,
  timingFunction,
  type: "spin"
});


/***/ }),

/***/ "./src/helpers/animation/useAnimatedProps.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useAnimatedProps": () => (/* binding */ useAnimatedProps)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("@emotion/react");
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_emotion_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _useAccessibilityListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/useAccessibilityListener/useAccessibilityListener.tsx");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/animation/helpers.ts");




const spinKeyframes = _emotion_react__WEBPACK_IMPORTED_MODULE_1__.keyframes`
from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const toCubicBezier = (timingFunction) => `cubic-bezier(${timingFunction.x1}, ${timingFunction.y1}, ${timingFunction.x2}, ${timingFunction.y2})`;
const useAnimatedProps = (props, animated = []) => {
  const { hasReducedMotion } = (0,_useAccessibilityListener__WEBPACK_IMPORTED_MODULE_2__.useAccessibilityListener)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (hasReducedMotion) {
      return void 0;
    }
    const styles = {};
    const animatedList = Array.isArray(animated) ? animated : [animated];
    const transition = animatedList.reduce((acc, animatedProp) => {
      if (!(0,_helpers__WEBPACK_IMPORTED_MODULE_3__.isTransition)(animatedProp)) {
        return acc;
      }
      const { delay = 0, duration, timingFunction = "ease" } = animatedProp;
      const animationTimingFunction = typeof timingFunction === "string" ? timingFunction : toCubicBezier(timingFunction);
      animatedProp.propNames.forEach((name) => {
        let propName;
        if (name.startsWith("transform")) {
          propName = "transform";
        } else {
          propName = name;
        }
        if (!acc.includes(propName)) {
          acc.push(
            `${propName.replace(
              /([a-z])([A-Z])/g,
              "$1-$2"
            )} ${duration}ms ${animationTimingFunction} ${delay}s`
          );
        }
      });
      return acc;
    }, []).join(",");
    if (transition) {
      styles.transition = transition;
    }
    const spinningAnimation = animatedList.find(_helpers__WEBPACK_IMPORTED_MODULE_3__.isSpinningAnimation);
    if (spinningAnimation) {
      const {
        iterations,
        revolutionDuration,
        timingFunction = "linear"
      } = spinningAnimation;
      styles.animation = `${spinKeyframes} ${revolutionDuration}ms ${typeof timingFunction === "string" ? timingFunction : toCubicBezier(timingFunction)} ${iterations ? iterations.toString() : "infinite"}`;
    }
    return styles;
  }, [hasReducedMotion]);
};


/***/ }),

/***/ "./src/helpers/color/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HexColor": () => (/* binding */ HexColor),
/* harmony export */   "hexColor": () => (/* binding */ hexColor),
/* harmony export */   "resolveColor": () => (/* binding */ resolveColor)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__);

class HexColor {
  constructor(c) {
    this.color = c;
  }
  toString() {
    return this.color;
  }
}
const hexColor = (color) => new HexColor(color);
const resolveColor = (color) => {
  return color instanceof HexColor ? color.toString() : _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.colors[color];
};


/***/ }),

/***/ "./src/helpers/element/element.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "element": () => (/* binding */ element)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("@emotion/react");
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_emotion_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("@emotion/css");
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_emotion_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/platform/Platform.ts");




const PROCESS_STYLE_EXTRACTION = _platform__WEBPACK_IMPORTED_MODULE_3__.Platform.isServer;
const element = (base, props, overridable) => {
  const element2 = overridable || base;
  const { css: cssProp, ...restProps } = props;
  const processClassName = (customClassNames) => {
    const className = (0,_emotion_css__WEBPACK_IMPORTED_MODULE_2__.css)(cssProp);
    const filteredClassNames = customClassNames.filter(Boolean);
    return {
      ...restProps,
      className: [className, ...filteredClassNames].join(" ")
    };
  };
  if (typeof element2 === "string") {
    return createFromTag(
      element2,
      PROCESS_STYLE_EXTRACTION ? props : processClassName([restProps.className])
    );
  }
  return createFromElement(
    element2,
    PROCESS_STYLE_EXTRACTION ? props : processClassName([restProps.className, element2.props.className])
  );
};
const createFromTag = (Element, props) => {
  const create = PROCESS_STYLE_EXTRACTION ? _emotion_react__WEBPACK_IMPORTED_MODULE_1__.jsx : react__WEBPACK_IMPORTED_MODULE_0__.createElement;
  return create(Element, props);
};
const createFromElement = (Element, props) => {
  return PROCESS_STYLE_EXTRACTION ? (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.jsx)(Element.type, {
      key: Element.key,
      ref: Element.ref,
      ...Element.props,
      ...props
    })
  ) : (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(Element, props);
};


/***/ }),

/***/ "./src/helpers/nodash/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "chunk": () => (/* binding */ chunk),
/* harmony export */   "flatten": () => (/* binding */ flatten),
/* harmony export */   "isNil": () => (/* binding */ isNil),
/* harmony export */   "merge": () => (/* binding */ merge),
/* harmony export */   "noop": () => (/* binding */ noop),
/* harmony export */   "omit": () => (/* binding */ omit),
/* harmony export */   "orderBy": () => (/* binding */ orderBy),
/* harmony export */   "pick": () => (/* binding */ pick),
/* harmony export */   "range": () => (/* binding */ range),
/* harmony export */   "seed": () => (/* binding */ seed),
/* harmony export */   "split": () => (/* binding */ split)
/* harmony export */ });
const isNil = (value) => value === null || value === void 0;
const noop = () => {
};
const flatten = (items) => items.reduce((acc, item) => acc.concat(item), []);
const range = (start, end) => {
  if (start > end) {
    return [];
  }
  const acc = [];
  let i = 0;
  for (i = 0; i < end; i += 1) {
    acc.push(i);
  }
  return acc;
};
const pick = (keys, object) => {
  const pickedObject = {};
  keys.forEach((key) => {
    pickedObject[key] = object[key];
  });
  return pickedObject;
};
const omit = (keys, object) => Object.keys(object).reduce((acc, key) => {
  if (!keys.includes(key)) {
    acc[key] = object[key];
  }
  return acc;
}, {});
const split = (keys, object) => [
  pick(keys, object),
  omit(keys, object)
];
const orderBy = (sortByPredicate, sortDirection, data) => [...data].sort((left, right) => {
  const valueLeft = typeof sortByPredicate === "function" ? sortByPredicate(left) : left[sortByPredicate];
  const valueRight = typeof sortByPredicate === "function" ? sortByPredicate(right) : right[sortByPredicate];
  if (isNil(valueLeft) && isNil(valueRight)) {
    return 0;
  }
  if (isNil(valueLeft)) {
    return 1;
  }
  if (isNil(valueRight)) {
    return -1;
  }
  const direction = sortDirection === "asc" ? 1 : -1;
  return valueLeft > valueRight ? direction : -direction;
});
const chunk = (array, size) => {
  if (size <= 0) {
    return [array];
  }
  const tmpArray = [...array];
  const chunks = [];
  while (tmpArray.length > 0) {
    chunks.push(tmpArray.splice(0, size));
  }
  return chunks;
};
const merge = (...objects) => {
  const isObject = (obj) => obj && typeof obj === "object";
  return objects.reduce((mergedObject, obj) => {
    Object.keys(obj).forEach((key) => {
      const targetValue = mergedObject[key];
      const sourceValue = obj[key];
      if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
        mergedObject[key] = [...targetValue, ...sourceValue];
      } else if (isObject(targetValue) && isObject(sourceValue)) {
        mergedObject[key] = merge(targetValue, sourceValue);
      } else {
        mergedObject[key] = sourceValue;
      }
    });
    return mergedObject;
  }, {});
};
const seed = (value) => {
  let seedValue = value;
  return function random() {
    const randomValue = Math.sin(seedValue++) * 1e4;
    return randomValue - Math.floor(randomValue);
  };
};


/***/ }),

/***/ "./src/helpers/platform/Platform.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Platform": () => (/* binding */ Platform)
/* harmony export */ });
const getBrowserType = () => {
  if (typeof navigator === "undefined") {
    return void 0;
  }
  const userAgent = navigator.userAgent.toLowerCase();
  switch (true) {
    case userAgent.includes("msie"):
      return "ie";
    case userAgent.includes("firefox"):
      return "firefox";
    case userAgent.includes("opr"):
      return "opera";
    case userAgent.includes("chrome"):
      return "chrome";
    case userAgent.includes("safari"):
      return "safari";
    default:
      return void 0;
  }
};
const IS_SERVER = typeof window === "undefined";
const Platform = {
  browserType: getBrowserType(),
  isServer: IS_SERVER
};


/***/ }),

/***/ "./src/helpers/platform/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Platform": () => (/* reexport safe */ _Platform__WEBPACK_IMPORTED_MODULE_0__.Platform),
/* harmony export */   "isDevEnvironment": () => (/* binding */ isDevEnvironment),
/* harmony export */   "isTestingEnvironment": () => (/* binding */ isTestingEnvironment)
/* harmony export */ });
/* harmony import */ var _Platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/platform/Platform.ts");

const isTestingEnvironment = "development" === "test";
const isDevEnvironment = "development" !== "production";


/***/ }),

/***/ "./src/helpers/properties/accessibility.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToAccessibility": () => (/* binding */ mapPropsToAccessibility)
/* harmony export */ });
const mapPropsToAccessibility = ({
  accessibilityChecked,
  accessibilityCurrent,
  accessibilityHidden,
  accessibilityLabel,
  accessibilityDisabled,
  accessibilityOwns,
  accessibilityPopupRole,
  accessibilityPopupExtended = false
}, boxProps) => {
  if (accessibilityLabel !== void 0) {
    boxProps["aria-label"] = accessibilityLabel;
  }
  if (accessibilityHidden !== void 0) {
    boxProps["aria-hidden"] = accessibilityHidden;
  }
  if (accessibilityDisabled !== void 0) {
    boxProps["aria-disabled"] = accessibilityDisabled;
  }
  if (accessibilityChecked !== void 0) {
    boxProps["aria-checked"] = accessibilityChecked;
  }
  if (accessibilityCurrent !== void 0) {
    boxProps["aria-current"] = accessibilityCurrent;
  }
  if (accessibilityPopupRole !== void 0) {
    boxProps["aria-haspopup"] = accessibilityPopupRole;
    boxProps["aria-expanded"] = accessibilityPopupExtended;
    boxProps["aria-owns"] = accessibilityOwns;
  }
};


/***/ }),

/***/ "./src/helpers/properties/border.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToBorder": () => (/* binding */ mapPropsToBorder)
/* harmony export */ });
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/color/index.ts");
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");


const directions = ["Top", "Right", "Bottom", "Left"];
const mapPropsToBorderLine = ({
  borderColor,
  borderStyle,
  borderWidth,
  ...restProps
}) => {
  return directions.reduce((style, direction) => {
    const colorProp = `border${direction}Color`;
    const widthProp = `border${direction}Width`;
    const color = restProps[colorProp] || borderColor;
    const hasBorder = color && borderWidth !== 0;
    if (hasBorder) {
      style[widthProp] = restProps[widthProp] || borderWidth || 1;
      style[colorProp] = (0,_color__WEBPACK_IMPORTED_MODULE_0__.resolveColor)(color);
      if (!style.borderStyle) {
        style.borderStyle = borderStyle || "solid";
      }
    }
    return style;
  }, {});
};
const mapPropsToBorder = ({
  borderRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  ...restProps
}, styles, mediaQueries = {}) => {
  const blr = borderBottomLeftRadius || borderRadius;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(blr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(blr, styles, mediaQueries, "borderBottomLeftRadius");
  } else {
    styles.borderBottomLeftRadius = blr;
  }
  const brr = borderBottomRightRadius || borderRadius;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(brr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(brr, styles, mediaQueries, "borderBottomRightRadius");
  } else {
    styles.borderBottomRightRadius = brr;
  }
  const tlr = borderTopLeftRadius || borderRadius;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(tlr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(tlr, styles, mediaQueries, "borderTopLeftRadius");
  } else {
    styles.borderTopLeftRadius = tlr;
  }
  const trr = borderTopRightRadius || borderRadius;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(trr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(trr, styles, mediaQueries, "borderTopRightRadius");
  } else {
    styles.borderTopRightRadius = trr;
  }
  Object.assign(styles, mapPropsToBorderLine(restProps));
};


/***/ }),

/***/ "./src/helpers/properties/dimension.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToDimension": () => (/* binding */ mapPropsToDimension)
/* harmony export */ });
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");

const mapPropsToDimension = ({
  height,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  overflow,
  width
}, styles, mediaQueries = {}) => {
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(height)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(height, styles, mediaQueries, "height");
  } else {
    styles.height = height;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(maxHeight)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(maxHeight, styles, mediaQueries, "maxHeight");
  } else {
    styles.maxHeight = maxHeight;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(maxWidth)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(maxWidth, styles, mediaQueries, "maxWidth");
  } else {
    styles.maxWidth = maxWidth;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(width)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(width, styles, mediaQueries, "width");
  } else {
    styles.width = width;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(minHeight)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(minHeight, styles, mediaQueries, "minHeight");
  } else {
    styles.minHeight = minHeight;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(minWidth)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(minWidth, styles, mediaQueries, "minWidth");
  } else {
    styles.minWidth = minWidth;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(overflow)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(overflow, styles, mediaQueries, "overflow");
  } else {
    styles.overflow = overflow;
  }
};


/***/ }),

/***/ "./src/helpers/properties/flexChild.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToFlexChild": () => (/* binding */ mapPropsToFlexChild)
/* harmony export */ });
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");

const mapPropsToFlexChild = ({ alignSelf, flexBasis, flexGrow, flexShrink }, styles, mediaQueries = {}) => {
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(alignSelf)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(alignSelf, styles, mediaQueries, "alignSelf");
  } else {
    styles.alignSelf = alignSelf;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(flexBasis)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(flexBasis, styles, mediaQueries, "flexBasis");
  } else {
    styles.flexBasis = flexBasis;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(flexGrow)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(flexGrow, styles, mediaQueries, "flexGrow");
  } else {
    styles.flexGrow = flexGrow;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(flexShrink)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(flexShrink, styles, mediaQueries, "flexShrink");
  } else {
    styles.flexShrink = flexShrink;
  }
};


/***/ }),

/***/ "./src/helpers/properties/flexContainer.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToFlexContainer": () => (/* binding */ mapPropsToFlexContainer)
/* harmony export */ });
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");

const mapPropsToFlexContainer = ({
  alignItems,
  direction = "column",
  flexWrap,
  justifyContent
}, styles, mediaQueries = {}) => {
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(alignItems)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(alignItems, styles, mediaQueries, "alignItems");
  } else {
    styles.alignItems = alignItems;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(direction)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(direction, styles, mediaQueries, "flexDirection");
  } else {
    styles.flexDirection = direction;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(flexWrap)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(flexWrap, styles, mediaQueries, "flexWrap");
  } else {
    styles.flexWrap = flexWrap;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(justifyContent)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(justifyContent, styles, mediaQueries, "justifyContent");
  } else {
    styles.justifyContent = justifyContent;
  }
};


/***/ }),

/***/ "./src/helpers/properties/margin.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToMargin": () => (/* binding */ mapPropsToMargin)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");


const getValue = (value) => {
  if ((0,_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.isSpacingToken)(value)) {
    return _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.spacings[value];
  }
  return value;
};
const mapPropsToMargin = ({
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  marginY,
  marginX,
  margin
}, styles, mediaQueries = {}) => {
  const mb = marginBottom || marginY || margin;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(mb)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(mb, styles, mediaQueries, "marginBottom", getValue);
  } else {
    styles.marginBottom = getValue(mb);
  }
  const ml = marginLeft || marginX || margin;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(ml)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(ml, styles, mediaQueries, "marginLeft", getValue);
  } else {
    styles.marginLeft = getValue(ml);
  }
  const mr = marginRight || marginX || margin;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(mr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(mr, styles, mediaQueries, "marginRight", getValue);
  } else {
    styles.marginRight = getValue(mr);
  }
  const mt = marginTop || marginY || margin;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(mt)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(mt, styles, mediaQueries, "marginTop", getValue);
  } else {
    styles.marginTop = getValue(mt);
  }
};


/***/ }),

/***/ "./src/helpers/properties/padding.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getValue": () => (/* binding */ getValue),
/* harmony export */   "mapPropsToPadding": () => (/* binding */ mapPropsToPadding)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");


const getValue = (value) => {
  if ((0,_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.isSpacingToken)(value)) {
    return _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.spacings[value];
  }
  return value;
};
const mapPropsToPadding = ({
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingY,
  paddingX,
  padding
}, styles, mediaQueries = {}) => {
  const pb = paddingBottom || paddingY || padding;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(pb)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(pb, styles, mediaQueries, "paddingBottom", getValue);
  } else {
    styles.paddingBottom = getValue(pb);
  }
  const pl = paddingLeft || paddingX || padding;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(pl)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(pl, styles, mediaQueries, "paddingLeft", getValue);
  } else {
    styles.paddingLeft = getValue(pl);
  }
  const pr = paddingRight || paddingX || padding;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(pr)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(pr, styles, mediaQueries, "paddingRight", getValue);
  } else {
    styles.paddingRight = getValue(pr);
  }
  const pt = paddingTop || paddingY || padding;
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_1__.isBreakpointValue)(pt)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_1__.handleResponsive)(pt, styles, mediaQueries, "paddingTop", getValue);
  } else {
    styles.paddingTop = getValue(pt);
  }
};


/***/ }),

/***/ "./src/helpers/properties/position.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToPosition": () => (/* binding */ mapPropsToPosition)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");


const mapPropsToPosition = ({ absoluteFill, position, top, left, bottom, right }, styles, mediaQueries = {}) => {
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(position)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(position, styles, mediaQueries, "position");
  } else {
    styles.position = position;
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(top)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(top, styles, mediaQueries, "top", getValue);
  } else {
    styles.top = getValue(top);
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(left)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(left, styles, mediaQueries, "left", getValue);
  } else {
    styles.left = getValue(left);
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(bottom)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(bottom, styles, mediaQueries, "bottom", getValue);
  } else {
    styles.bottom = getValue(bottom);
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(right)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(right, styles, mediaQueries, "right", getValue);
  } else {
    styles.right = getValue(right);
  }
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(absoluteFill)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(
      absoluteFill,
      styles,
      mediaQueries,
      "position",
      () => "absolute"
    );
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(absoluteFill, styles, mediaQueries, "left", () => 0);
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(absoluteFill, styles, mediaQueries, "right", () => 0);
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(absoluteFill, styles, mediaQueries, "bottom", () => 0);
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(absoluteFill, styles, mediaQueries, "top", () => 0);
  } else if (absoluteFill) {
    styles.position = "absolute";
    styles.bottom = 0;
    styles.left = 0;
    styles.right = 0;
    styles.top = 0;
  }
};
const getValue = (value) => {
  if ((0,_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.isSpacingToken)(value)) {
    return _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.spacings[value];
  }
  return value;
};


/***/ }),

/***/ "./src/helpers/properties/responsive/responsive.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NEXT_SMALLEST_BREAKPOINT_MAP": () => (/* binding */ NEXT_SMALLEST_BREAKPOINT_MAP),
/* harmony export */   "handleResponsive": () => (/* binding */ handleResponsive),
/* harmony export */   "isBreakpointValue": () => (/* binding */ isBreakpointValue),
/* harmony export */   "resolveBreakpointValue": () => (/* binding */ resolveBreakpointValue)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__);

const media = {
  small: `@media (min-width: ${_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.breakpoints.small}px)`,
  medium: `@media (min-width: ${_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.breakpoints.medium}px)`,
  large: `@media (min-width: ${_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.breakpoints.large}px)`,
  xlarge: `@media (min-width: ${_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.breakpoints.xlarge}px)`
};
const handleResponsive = (prop, styles, mediaQueries, key, getValue) => {
  const setValueForMediaQuery = (breakpointKey) => {
    const breakpointValue = prop[breakpointKey];
    if (breakpointValue === void 0) {
      return;
    }
    const value = typeof getValue === "function" ? getValue(breakpointValue) : breakpointValue;
    const mediaObject = mediaQueries[media[breakpointKey]];
    if (mediaObject)
      mediaObject[key] = value;
    else
      mediaQueries[media[breakpointKey]] = { [key]: value };
  };
  if (prop.xsmall !== void 0) {
    styles[key] = typeof getValue === "function" ? getValue(prop.xsmall) : prop.xsmall;
  }
  setValueForMediaQuery("small");
  setValueForMediaQuery("medium");
  setValueForMediaQuery("large");
  setValueForMediaQuery("xlarge");
};
const isBreakpointValue = (prop) => {
  return typeof prop === "object" && prop != null && ("xsmall" in prop || "small" in prop || "medium" in prop || "large" in prop || "xlarge" in prop);
};
const breakpointKeys = Object.keys(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_0__.breakpoints);
const NEXT_SMALLEST_BREAKPOINT_MAP = breakpointKeys.reduce(
  (acc, bp, currentIndex) => {
    if (currentIndex === 0) {
      acc[bp] = void 0;
    } else {
      acc[bp] = breakpointKeys[currentIndex - 1];
    }
    return acc;
  },
  {}
);
const resolveBreakpointValue = (prop, breakpointKey) => {
  if (prop[breakpointKey] !== void 0) {
    return prop[breakpointKey];
  } else {
    const nextSmallestBreakpoint = NEXT_SMALLEST_BREAKPOINT_MAP[breakpointKey];
    if (!nextSmallestBreakpoint)
      return;
    return resolveBreakpointValue(prop, nextSmallestBreakpoint);
  }
};


/***/ }),

/***/ "./src/helpers/properties/shadow/mapPropsToShadow.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToShadow": () => (/* binding */ mapPropsToShadow)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/color/index.ts");


const OUTLINE_SHADOW = `0 0 0 ${2}px ${(0,_color__WEBPACK_IMPORTED_MODULE_0__.resolveColor)("blue60")}`;
const mapPropsToShadow = ({ shadow, withOutline }, styles) => {
  const outlineShadow = withOutline ? OUTLINE_SHADOW : void 0;
  const normalShadow = shadow ? _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.shadows[shadow] : void 0;
  styles["&:focus"] = {
    outline: "2px solid transparent"
  };
  styles.boxShadow = [outlineShadow, normalShadow].filter(Boolean).join(",");
};


/***/ }),

/***/ "./src/helpers/properties/stacking.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StackingContextProvider": () => (/* binding */ StackingContextProvider),
/* harmony export */   "createZIndex": () => (/* binding */ createZIndex),
/* harmony export */   "mapPropsToStacking": () => (/* binding */ mapPropsToStacking),
/* harmony export */   "useStackingContext": () => (/* binding */ useStackingContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__);


const mapPropsToStacking = ({ stackLayer, stackPriority }, styles) => {
  if (stackLayer || stackPriority) {
    styles.zIndex = createZIndex({ stackLayer, stackPriority });
  }
};
const StackingContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const StackingContextProvider = StackingContext.Provider;
const createZIndex = ({
  stackLayer = "default",
  stackPriority = 0
}) => {
  return _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.stackings[stackLayer] + stackPriority;
};
const useStackingContext = ({
  stackLayer,
  stackPriority
}) => {
  const stackContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StackingContext);
  if (stackContext) {
    return {
      stackLayer: stackContext.stackLayer,
      stackPriority: stackContext.stackPriority
    };
  }
  return {
    stackLayer,
    stackPriority
  };
};


/***/ }),

/***/ "./src/helpers/properties/testing.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToTestingProps": () => (/* binding */ mapPropsToTestingProps)
/* harmony export */ });
const mapPropsToTestingProps = ({ testId }, boxProps) => {
  if (testId === void 0)
    return;
  boxProps["data-testid"] = testId;
};


/***/ }),

/***/ "./src/helpers/properties/transforms.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToTransforms": () => (/* binding */ mapPropsToTransforms)
/* harmony export */ });
const mapPropsToTransforms = ({ transform }, styles) => {
  if (transform) {
    styles.transform = transform.map((t) => {
      const [keyValuePair] = Object.entries(t);
      const transformFunction = keyValuePair[0];
      let value = keyValuePair[1];
      if (transformFunction === "translateX" || transformFunction === "translateY") {
        value = `${value}px`;
      }
      return `${transformFunction}(${value})`;
    }).join(" ");
  }
};


/***/ }),

/***/ "./src/helpers/properties/visiblyHidden/visiblyHidden.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToVisiblyHidden": () => (/* binding */ mapPropsToVisiblyHidden)
/* harmony export */ });
const mapPropsToVisiblyHidden = ({ visiblyHidden }, styles) => {
  if (visiblyHidden) {
    styles.clip = "rect(1, 1, 1, 1)";
    styles.clipPath = "inset(50%)";
    styles.height = 1;
    styles.margin = -1;
    styles.overflow = "hidden";
    styles.padding = 0;
    styles.position = "absolute";
    styles.width = 1;
  }
};


/***/ }),

/***/ "./src/helpers/properties/web.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mapPropsToWeb": () => (/* binding */ mapPropsToWeb)
/* harmony export */ });
/* harmony import */ var _responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/properties/responsive/responsive.ts");

const mapPropsToWeb = ({ display }, styles, mediaQueries = {}) => {
  if ((0,_responsive__WEBPACK_IMPORTED_MODULE_0__.isBreakpointValue)(display)) {
    (0,_responsive__WEBPACK_IMPORTED_MODULE_0__.handleResponsive)(display, styles, mediaQueries, "display");
  } else {
    styles.display = display;
  }
};


/***/ }),

/***/ "./src/helpers/useAccessibilityListener/constants/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFAULT_REDUCED_MOTION": () => (/* binding */ DEFAULT_REDUCED_MOTION),
/* harmony export */   "DEFAULT_RING_VISIBILITY": () => (/* binding */ DEFAULT_RING_VISIBILITY)
/* harmony export */ });
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/platform/index.ts");

const DEFAULT_REDUCED_MOTION = _platform__WEBPACK_IMPORTED_MODULE_0__.isTestingEnvironment;
const DEFAULT_RING_VISIBILITY = false;


/***/ }),

/***/ "./src/helpers/useAccessibilityListener/helpers/useFocusRing/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useFocusRing": () => (/* binding */ useFocusRing)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useAccessibilityListener/constants/index.ts");


const useFocusRing = () => {
  const isVisible = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(_constants__WEBPACK_IMPORTED_MODULE_1__.DEFAULT_RING_VISIBILITY);
  const getFocusRingVisibility = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => isVisible.current, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const hide = () => {
      isVisible.current = false;
    };
    const display = () => {
      isVisible.current = true;
    };
    window.addEventListener("mousemove", hide);
    window.addEventListener("mousedown", hide);
    window.addEventListener("keydown", display);
    return () => {
      window.removeEventListener("mousemove", hide);
      window.removeEventListener("mousedown", hide);
      window.removeEventListener("keydown", display);
    };
  }, []);
  return getFocusRingVisibility;
};


/***/ }),

/***/ "./src/helpers/useAccessibilityListener/helpers/useReducedMotion/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useReducedMotion": () => (/* binding */ useReducedMotion)
/* harmony export */ });
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/platform/Platform.ts");
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/platform/index.ts");
/* harmony import */ var _useMediaQueryListener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/useMediaQueryListener/useMediaQueryListener.ts");


const useReducedMotion = () => {
  return (0,_useMediaQueryListener__WEBPACK_IMPORTED_MODULE_0__.useMediaQueryListener)(
    "(prefers-reduced-motion: reduce)",
    // @note: animations are not reduced on server like envs (except testing env)
    // to allow CSS extraction on SSR (Server Side Rendering) / SSG (Static Site Generation)
    _platform__WEBPACK_IMPORTED_MODULE_1__.Platform.isServer ? false : _platform__WEBPACK_IMPORTED_MODULE_2__.isTestingEnvironment
  );
};


/***/ }),

/***/ "./src/helpers/useAccessibilityListener/useAccessibilityListener.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useAccessibilityListener": () => (/* binding */ useAccessibilityListener)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_useReducedMotion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useAccessibilityListener/helpers/useReducedMotion/index.ts");
/* harmony import */ var _helpers_useFocusRing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/useAccessibilityListener/helpers/useFocusRing/index.ts");



const useAccessibilityListener = () => {
  const hasReducedMotion = (0,_helpers_useReducedMotion__WEBPACK_IMPORTED_MODULE_1__.useReducedMotion)();
  const getFocusRingVisibility = (0,_helpers_useFocusRing__WEBPACK_IMPORTED_MODULE_2__.useFocusRing)();
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => ({ hasReducedMotion, getFocusRingVisibility }),
    [getFocusRingVisibility, hasReducedMotion]
  );
};


/***/ }),

/***/ "./src/helpers/useId/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MIDNIGHT_PREFIX": () => (/* binding */ MIDNIGHT_PREFIX),
/* harmony export */   "createNewId": () => (/* binding */ createNewId),
/* harmony export */   "useId": () => (/* binding */ useId)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

const MIDNIGHT_PREFIX = "MIDNIGHT";
let counter = 1;
const createNewId = () => {
  const id = `${MIDNIGHT_PREFIX}_${counter}`;
  counter += 1;
  return id;
};
const useId = (id) => (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => id || createNewId(), [id]);


/***/ }),

/***/ "./src/helpers/useIsomorphicLayoutEffect/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useIsomorphicLayoutEffect": () => (/* binding */ useIsomorphicLayoutEffect)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/platform/Platform.ts");
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/platform/index.ts");


const useIsomorphicLayoutEffect = _platform__WEBPACK_IMPORTED_MODULE_1__.Platform.isServer || _platform__WEBPACK_IMPORTED_MODULE_2__.isTestingEnvironment ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;


/***/ }),

/***/ "./src/helpers/useMediaQueryListener/useMediaQueryListener.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useMediaQueryListener": () => (/* binding */ useMediaQueryListener)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/helpers/platform/Platform.ts");
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/helpers/platform/index.ts");
/* harmony import */ var _useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/useIsomorphicLayoutEffect/index.ts");



const useMediaQueryListener = (query, fallbackValue = false) => {
  const mediaQuery = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => createMediaQuery(query), [query]);
  const [isMatched, setIsMatched] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    mediaQuery ? getIsMatchedMedia(mediaQuery) : fallbackValue
  );
  (0,_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_1__.useIsomorphicLayoutEffect)(() => {
    if (!mediaQuery) {
      return;
    }
    const handleMatchMedia = () => {
      setIsMatched(getIsMatchedMedia(mediaQuery));
    };
    mediaQuery.addListener(handleMatchMedia);
    return () => {
      mediaQuery.removeListener(handleMatchMedia);
    };
  });
  return isMatched;
};
const createMediaQuery = (query) => {
  const isRealBrowserEnvironment = !_platform__WEBPACK_IMPORTED_MODULE_2__.Platform.isServer && !_platform__WEBPACK_IMPORTED_MODULE_3__.isTestingEnvironment;
  return isRealBrowserEnvironment ? window.matchMedia(query) : null;
};
const getIsMatchedMedia = (mediaQuery) => {
  return mediaQuery.matches;
};


/***/ }),

/***/ "./src/helpers/useTheme/useTheme.tsx":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useTheme": () => (/* binding */ useTheme)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__);


const DEFAULT_THEME = {
  spacings: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.spacings,
  typographies: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.typographies
};
const useTheme = () => {
  const theme = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(DEFAULT_THEME);
  return theme.current;
};


/***/ }),

/***/ "./src/helpers/useToken/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useToken": () => (/* binding */ useToken)
/* harmony export */ });
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/index.js");
/* harmony import */ var _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/helpers/useTheme/useTheme.tsx");


const useToken = () => {
  const { spacings, typographies } = (0,_useTheme__WEBPACK_IMPORTED_MODULE_0__.useTheme)();
  return {
    breakpoints: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.breakpoints,
    colors: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.colors,
    radii: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.radii,
    shadows: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.shadows,
    spacings,
    stackings: _payfit_midnight_theme__WEBPACK_IMPORTED_MODULE_1__.stackings,
    typographies
  };
};


/***/ }),

/***/ "./src/helpers/useWarning/index.ts":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useWarning": () => (/* binding */ useWarning),
/* harmony export */   "warn": () => (/* binding */ warn)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _platform__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/helpers/platform/index.ts");


const warn = (data) => {
  if (!_platform__WEBPACK_IMPORTED_MODULE_1__.isDevEnvironment || _platform__WEBPACK_IMPORTED_MODULE_1__.isTestingEnvironment) {
    return;
  }
};
const useWarning = (data, isDisplayable = true) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (isDisplayable) {
      warn(data);
    }
  }, [data, isDisplayable]);
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/breakpoints.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.breakpoints = void 0;
// Breakpoint naming follows size property convention (eg. Avatar size...)
exports.breakpoints = {
    xsmall: 0,
    small: 576,
    medium: 768,
    large: 992,
    xlarge: 1280,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/colors.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.colors = void 0;
exports.colors = {
    black: '#000000',
    white: '#FFFFFF',
    // Blue
    blue400: '#011F40',
    blue300: '#094285',
    blue200: '#0C5AB3',
    blue100: '#0F6FDE',
    blue80: '#3587E6',
    blue60: '#89BEFA',
    blue40: '#B4D5FA',
    blue20: '#EBF4FF',
    // Azure
    azure400: '#002C33',
    azure300: '#007180',
    azure200: '#009BB0',
    azure100: '#00BFD9',
    azure80: '#2BC9DF',
    azure60: '#7EE0ED',
    azure40: '#B5ECF5',
    azure20: '#EBFCFF',
    // Purple
    purple400: '#1C0F46',
    purple300: '#371E8A',
    purple200: '#4926BD',
    purple100: '#5F34ED',
    purple80: '#7854F0',
    purple60: '#A890F5',
    purple40: '#CFC2F9',
    purple20: '#EFEBFF',
    // Green
    green400: '#002E14',
    green300: '#007332',
    green200: '#009C44',
    green100: '#00C455',
    green80: '#29CF71',
    green60: '#7BE0A7',
    green40: '#B6F0CF',
    green20: '#EBFFF3',
    // Yellow
    yellow400: '#382400',
    yellow300: '#996300',
    yellow200: '#CC8400',
    yellow100: '#FFA600',
    yellow80: '#FFB52B',
    yellow60: '#FFD17A',
    yellow40: '#FFEED1',
    yellow20: '#FFF6E6',
    // Red
    red400: '#470F0B',
    red300: '#901F16',
    red200: '#CD2C20',
    red100: '#F13426',
    red80: '#FF756B',
    red60: '#FF9D96',
    red40: '#FFC6C2',
    red20: '#FFEDEB',
    // Navy
    navy200: '#042040',
    navy100: '#132D4A',
    navy90: '#223954',
    navy80: '#364A61',
    navy70: '#485B70',
    navy60: '#55687D',
    navy50: '#65778C',
    navy40: '#768699',
    navy30: '#8594A6',
    navy20: '#96A3B3',
    // Silver
    silver300: '#ABBBCC',
    silver200: '#BAC8D6',
    silver100: '#D1DAE6',
    silver80: '#DFE6ED',
    silver60: '#EBF0F5',
    silver40: '#F0F3F7',
    silver20: '#F7F9FC',
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/index.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.theme = exports.breakpoints = exports.typographies = exports.stackings = exports.isSpacingToken = exports.spacings = exports.shadows = exports.radii = exports.colors = void 0;
var colors_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/colors.js");
Object.defineProperty(exports, "colors", ({ enumerable: true, get: function () { return colors_1.colors; } }));
var radii_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/radii.js");
Object.defineProperty(exports, "radii", ({ enumerable: true, get: function () { return radii_1.radii; } }));
var shadows_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/shadows.js");
Object.defineProperty(exports, "shadows", ({ enumerable: true, get: function () { return shadows_1.shadows; } }));
var spacings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/spacings.js");
Object.defineProperty(exports, "spacings", ({ enumerable: true, get: function () { return spacings_1.spacings; } }));
Object.defineProperty(exports, "isSpacingToken", ({ enumerable: true, get: function () { return spacings_1.isSpacingToken; } }));
var stackings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/stackings.js");
Object.defineProperty(exports, "stackings", ({ enumerable: true, get: function () { return stackings_1.stackings; } }));
var typographies_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/typographies.js");
Object.defineProperty(exports, "typographies", ({ enumerable: true, get: function () { return typographies_1.typographies; } }));
var breakpoints_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/breakpoints.js");
Object.defineProperty(exports, "breakpoints", ({ enumerable: true, get: function () { return breakpoints_1.breakpoints; } }));
var theme_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/theme.js");
Object.defineProperty(exports, "theme", ({ enumerable: true, get: function () { return theme_1.theme; } }));
__exportStar(__webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/index.js"), exports);


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/radii.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.radii = void 0;
exports.radii = {
    medium: 6,
    large: 8,
    xlarge: 16,
    rounded: 100,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/shadows.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shadows = void 0;
const getShadowValue = ({ x, y, blur, spread, color, }) => {
    return [`${x}px`, `${y}px`, `${blur}px`, `${spread}px`, color].join(' ');
};
const shadowBlack14 = 'rgba(0, 0, 0, 0.14)';
exports.shadows = {
    'shadow-100': getShadowValue({
        x: 0,
        y: 1,
        blur: 2,
        spread: 0,
        color: 'rgba(0, 0, 0, 0.05)',
    }),
    'shadow-150': getShadowValue({
        x: 0,
        y: 3,
        blur: 6,
        spread: -4,
        color: 'rgba(0, 0, 0, 0.22)',
    }),
    'shadow-200': getShadowValue({
        x: 0,
        y: 7,
        blur: 14,
        spread: -4,
        color: shadowBlack14,
    }),
    'shadow-300': getShadowValue({
        x: 0,
        y: 12,
        blur: 24,
        spread: -6,
        color: shadowBlack14,
    }),
    'shadow-400': getShadowValue({
        x: 0,
        y: 22,
        blur: 30,
        spread: -8,
        color: shadowBlack14,
    }),
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/spacings.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isSpacingToken = exports.spacings = void 0;
exports.spacings = {
    'spacing-0': 0,
    'spacing-40': 4,
    'spacing-60': 8,
    'spacing-80': 12,
    'spacing-100': 16,
    'spacing-200': 24,
    'spacing-300': 32,
    'spacing-400': 40,
    'spacing-500': 48,
    'spacing-600': 64,
};
const isSpacingToken = (value) => typeof value === 'string' ? value in exports.spacings : false;
exports.isSpacingToken = isSpacingToken;


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/stackings.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stackings = void 0;
exports.stackings = {
    default: 0,
    layout: 20,
    popover: 50,
    overlay: 100,
    notification: 150,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/theme.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.theme = void 0;
const colors_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/colors.js");
const radii_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/radii.js");
const shadows_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/shadows.js");
const spacings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/spacings.js");
const stackings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/stackings.js");
const typographies_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/typographies.js");
const breakpoints_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/breakpoints.js");
exports.theme = {
    colors: colors_1.colors,
    radii: radii_1.radii,
    shadows: shadows_1.shadows,
    spacings: spacings_1.spacings,
    stackings: stackings_1.stackings,
    typographies: typographies_1.typographies,
    breakpoints: breakpoints_1.breakpoints,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/typographies.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.typographies = void 0;
exports.typographies = {
    'text-700': {
        fontSize: 35,
        fontVariation: 'bold',
    },
    'text-600': {
        fontSize: 28,
        fontVariation: 'bold',
    },
    'text-500': {
        fontSize: 22,
        fontVariation: 'bold',
    },
    'text-400': {
        fontSize: 20,
        fontVariation: 'bold',
    },
    'text-300': {
        fontSize: 16,
        fontVariation: 'bold',
    },
    'text-200': {
        fontSize: 16,
        fontVariation: 'normal',
    },
    'text-100-medium': {
        fontSize: 14,
        fontVariation: 'bold',
    },
    'text-100': {
        fontSize: 14,
        fontVariation: 'normal',
    },
    'text-80': {
        fontSize: 13,
        fontVariation: 'normal',
    },
    'text-60-caps': {
        fontSize: 11,
        textTransform: 'uppercase',
        fontWeight: 600,
        fontVariation: 'normal',
    },
    'text-60': {
        fontSize: 11,
        fontVariation: 'normal',
    },
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/v2/breakpoints.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.breakpoints = void 0;
// Breakpoint naming follows size property convention (eg. Avatar size...)
exports.breakpoints = {
    xs: 0,
    sm: 490,
    md: 768,
    lg: 1040,
    xl: 1440,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/v2/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.V2Tokens = void 0;
const breakpoints_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/breakpoints.js");
const radii_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/radii.js");
const theme_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/theme.js");
exports.V2Tokens = {
    radii: radii_1.radii,
    breakpoints: breakpoints_1.breakpoints,
    theme: theme_1.theme,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/v2/radii.js":
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.radii = void 0;
exports.radii = {
    xs: 2,
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    '2xl': 24,
    '3xl': 32,
    /*
       This avoid unwanted elliptical shapes https://github.com/tailwindlabs/tailwindcss/issues/1949#issuecomment-650328183
       and ensure that the shape rendered will always be a circle
       */
    rounded: 9999,
};


/***/ }),

/***/ "./node_modules/@payfit/midnight-theme/dist/v2/theme.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.theme = void 0;
// V1 Tokens
const colors_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/colors.js");
const shadows_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/shadows.js");
const spacings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/spacings.js");
const stackings_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/stackings.js");
const typographies_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/typographies.js");
// V2 Tokens
const breakpoints_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/breakpoints.js");
const radii_1 = __webpack_require__("./node_modules/@payfit/midnight-theme/dist/v2/radii.js");
exports.theme = {
    colors: colors_1.colors,
    radii: radii_1.radii,
    shadows: shadows_1.shadows,
    spacings: spacings_1.spacings,
    stackings: stackings_1.stackings,
    typographies: typographies_1.typographies,
    breakpoints: breakpoints_1.breakpoints,
};


/***/ }),

/***/ "@emotion/css":
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__emotion_css__;

/***/ }),

/***/ "@emotion/react":
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__emotion_react__;

/***/ }),

/***/ "@payfit/midnight-utils":
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__payfit_midnight_utils__;

/***/ }),

/***/ "react":
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "react/jsx-runtime":
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Switch": () => (/* reexport safe */ _Switch__WEBPACK_IMPORTED_MODULE_0__.Switch)
/* harmony export */ });
/* harmony import */ var _Switch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/Switch/Switch.tsx");


})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map